import { render, staticRenderFns } from "./BookReading.vue?vue&type=template&id=4532dc68&"
import script from "./BookReading.vue?vue&type=script&lang=js&"
export * from "./BookReading.vue?vue&type=script&lang=js&"
import style0 from "./BookReading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports